import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Row } from 'seagull';
import { PromptInputField } from '~/components/ai/PromptInputField/PromptInputField';
import { usePromptSuggestions } from '~/hooks/reactQuery/queries/usePromptSuggestions';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { HelpMeWriteTextFieldTestIds, PresetType } from './HelpMeWriteTextField.types';
import PresetButton from './PresetButton';
const HelpMeWriteTextField = (param)=>{
    let { value, onChange, onSubmit, onPresetClick, isLoading = false, disabled = false, conversationId = '', isUndoLoading = false } = param;
    const { logBI } = useStoreActions();
    const { t: textFieldTexts } = useLocaleKeys('helpMeWrite.textField');
    const isDisabled = disabled || isLoading || isUndoLoading;
    const { suggestions } = usePromptSuggestions();
    const textFieldRef = useRef(null);
    const handlePresetClick = (preset)=>{
        const eventIdMap = {
            [PresetType.Formalize]: 17004,
            [PresetType.Polish]: 17005,
            [PresetType.Shorten]: 17006,
            [PresetType.Elaborate]: 17007
        };
        logBI(eventIdMap[preset]);
        onPresetClick(preset);
    };
    const handleSubmit = ()=>{
        if (value === null || value === void 0 ? void 0 : value.trim()) {
            logBI(17009, {
                text: value.trim()
            });
        }
        onChange('');
        onSubmit();
    };
    const presetButtons = [
        {
            type: PresetType.Formalize,
            onClick: ()=>handlePresetClick(PresetType.Formalize)
        },
        {
            type: PresetType.Polish,
            onClick: ()=>handlePresetClick(PresetType.Polish)
        },
        {
            type: PresetType.Elaborate,
            onClick: ()=>handlePresetClick(PresetType.Elaborate)
        },
        {
            type: PresetType.Shorten,
            onClick: ()=>handlePresetClick(PresetType.Shorten)
        }
    ];
    const animatedSuggestions = conversationId ? [] : suggestions;
    useEffect(()=>{
        if (!isDisabled && textFieldRef.current) {
            const timeoutId = setTimeout(()=>{
                var _textFieldRef_current;
                const textarea = (_textFieldRef_current = textFieldRef.current) === null || _textFieldRef_current === void 0 ? void 0 : _textFieldRef_current.querySelector('textarea');
                if (textarea) {
                    textarea.focus();
                }
            }, 300);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        isDisabled
    ]);
    return /*#__PURE__*/ _jsx(PromptInputField, {
        testId: HelpMeWriteTextFieldTestIds.Root(),
        value: value,
        onChange: onChange,
        onSubmit: handleSubmit,
        disabled: isDisabled,
        submitDisabled: isDisabled,
        suggestions: animatedSuggestions,
        placeholder: textFieldTexts.placeholder(),
        inputContainerRef: textFieldRef,
        leftActions: /*#__PURE__*/ _jsx(Row, {
            gap: 8,
            children: presetButtons.map((param)=>{
                let { type, onClick } = param;
                return /*#__PURE__*/ _jsx(PresetButton, {
                    onClick: onClick,
                    disabled: isDisabled,
                    testId: HelpMeWriteTextFieldTestIds[type](),
                    text: type
                }, type);
            })
        })
    });
};
export default HelpMeWriteTextField;
